export enum NotPurchasableReason {
  NOT_PURCHASABLE_UNSET_TYPE = 'NOT_PURCHASABLE_UNSET_TYPE', // Do not use, needed because of proto3 limitations
  NOT_PURCHASABLE_NO_BASE_PLAN = 'NOT_PURCHASABLE_NO_BASE_PLAN',
  NOT_PURCHASABLE_MAX_QUEUED_ALLOWANCE = 'NOT_PURCHASABLE_MAX_QUEUED_ALLOWANCE',
  NOT_PURCHASABLE_UNPAID = 'NOT_PURCHASABLE_UNPAID',
}
